import { Layout } from 'core-ui';
import { Outlet } from 'react-router-dom';
import Header from './components/Header';
import Logo from './components/Logo';
import SideMenu from './components/SideMenu';
import { useContext, useEffect, useState } from 'react';
import useResponsive from 'src/hooks/useResponsive';
import MobileDrawer from './components/MobileDrawer';
import { ProfileContext } from 'src/contexts/profile';

const MainLayout = () => {
  const [openDrawer, setOpenDrawer] = useState(false);
  const { isMobile } = useResponsive();
  const { profile } = useContext(ProfileContext);

  useEffect(() => {
    if (!isMobile) {
      setOpenDrawer(false);
    }
  }, [isMobile]);

  const handleOpenDrawer = () => {
    setOpenDrawer(true);
  };

  return (
    <Layout
      headerContent={<Header handleOpenDrawer={() => setOpenDrawer(true)} />}
      logoContent={<Logo />}
      defaultSiderWidth={220}
      hideCollapser
      contentStyle={{
        overflow: 'auto'
      }}
      customSider={<SideMenu />}
      siderClassName="max-[820px]:hidden"
    >
      <MobileDrawer
        open={openDrawer}
        onClose={() => setOpenDrawer(false)}
        userName={profile?.name || ''}
      />
      <Outlet />
    </Layout>
  );
};

export default MainLayout;
